import { render, staticRenderFns } from "./ToolLink.vue?vue&type=template&id=1cf0a68c"
import script from "./ToolLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./ToolLink.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports